import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { AddressFormModal } from "@/components/Checkout/CheckoutCustomer/addresses/components/addresFormModal/addressFormModal";
import { AddressListModal } from "@/components/Checkout/CheckoutCustomer/addresses/components/addressListModal/addressListModal";
import { DeliveryAddress } from "@/components/Checkout/CheckoutCustomer/addresses/components/deliveryAddress/deliveryAddress";
import { PaymentAddress } from "@/components/Checkout/CheckoutCustomer/addresses/components/paymentAddress/paymentAddress";
import { RequestInvoice } from "@/components/Checkout/CheckoutCustomer/addresses/components/requestInvoice/requestInvoice";
import { SamePaymentAddress } from "@/components/Checkout/CheckoutCustomer/addresses/components/samePaymentAddress/samePaymentAddress";
import { useAddresses } from "@/components/Checkout/CheckoutCustomer/addresses/hooks/useAddresses.hook";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";

const CheckoutCustomerAddressesContainer = () => {
    const { hasAddresses } = useAddresses();

    const isHomeDelivery = useSelector(CartSelectors.hasHomeDelivery);

    return (
        <>
            {isHomeDelivery && (
                <>
                    <DeliveryAddress className={cn("mb-4")} />
                    <SamePaymentAddress className={cn("mb-4")} />
                </>
            )}
            <RequestInvoice className={cn("mb-4")} />
            <PaymentAddress className={cn("mb-4")} />
            {hasAddresses && (
                <>
                    <AddressListModal />
                    <AddressFormModal />
                </>
            )}
        </>
    );
};

export { CheckoutCustomerAddressesContainer };
